import type AppStore from '@src/app/AppStore'

import CustomProtocolHandler, {
  PROTOCOL_OPENPHONE_WEB as PROTOCOL,
} from './CustomProtocolHandler'

export { PROTOCOL }

export default class WebOpenPhoneProtocolHandler extends CustomProtocolHandler {
  override readonly protocol = PROTOCOL
  override readonly web = true
  override readonly desktop = false

  constructor(app: AppStore) {
    super(app, PROTOCOL)
  }
}
